'use strict'

import { AcrossLite } from './across_lite.js'
import { Jpz } from './jpz.js'
import { PaJson } from './pa_json.js'
import { PzlJson } from './pzl_json.js'
import { PzlSvg } from './pzl_svg.js'

export function dasherize (str) {
  return str.replace(/[\s_]/, '-')
}

export function cssClassify (str) {
  return '.' + str
}

export function detectFile (fn) {
  let xw

  switch (detectFiletypeFromName(fn)) {
    case 'jpz':
      xw = new Jpz()
      break
    case 'pa_json':
      xw = new PaJson()
      break
    case 'pzl_json':
      xw = new PzlJson()
      break
    case 'svg':
      xw = new PzlSvg()
      break
    default:
      xw = new AcrossLite()
  }

  return xw
}

export function detectFiletypeFromName (f) {
  let filetype = 'across_lite'
  let ext = f.name.match(/.(\w+)$/)[1].toLowerCase()

  switch (ext) {
    case 'jpz':
      filetype = 'jpz'
      break
    case 'js':
      filetype = 'pa_json'
      break
    case 'json':
      filetype = 'pa_json'
      break
    case 'svg':
      filetype = 'svg'
      break
  }
  return filetype
}

export function convertBuffer (buffer) {
  let dataview = new DataView(buffer)
  let byteArray = new Uint8Array(buffer.byteLength)

  for (let i = 0; i < buffer.byteLength; i++) {
    byteArray[i] = dataview.getUint8(i).toString(10)
  }

  return byteArray
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/helpers.js
// module id = 909
// module chunks = 0